module.exports = __webpack_public_path__ + "img/logo.9d45b32b.png";